import React from 'react';
import { OrderStatus } from '@src/pages/Deliveries/context/orders';
import { globalStyles } from 'snacks-design-system';
import { Statuses } from '@src/pages/DeliveryDashboard/models/model-constants';
import styles from './OrderMapMarker.module.scss';
import { IconCheck, IconReceipt, IconReceiptSuccess } from '@justeattakeaway/pie-icons-react';
interface OrderMapMarkerIconProps {
  orderStatus: OrderStatus;
}

export const OrderMapMarkerIcon = ({ orderStatus }: OrderMapMarkerIconProps) => {
  const { xdsColorSupportPositive } = globalStyles;

  const getIconClassName = () => {
    if (orderStatus !== Statuses.Unassigned && orderStatus !== Statuses.Delivered) {
      return styles.OrderMapMarkerIconActive;
    } else if (orderStatus === Statuses.Unassigned) {
      return styles.OrderMapMarkerIconIdle;
    } else {
      return styles.OrderMapMarkerDelivered;
    }
  };
  const icons = {
    [OrderStatus.InDelivery]: <IconReceiptSuccess size="xs" />,
    [OrderStatus.Delivered]: <IconCheck color={xdsColorSupportPositive} size="xs" />,
    [OrderStatus.Unassigned]: <IconReceipt size="xs" />,
    [OrderStatus.Assigned]: <IconReceiptSuccess size="xs" />,
    [OrderStatus.AssignedToNextPool]: <IconReceiptSuccess size="xs" />,
  };
  return (
    <div
      className={`OrderMapMarkerIcon ${styles.OrderMapMarkerIconContainer} ${getIconClassName()}`}
    >
      {icons[orderStatus]}
    </div>
  );
};

export default OrderMapMarkerIcon;
